import React, { ReactNode } from "react";

import { ITabsVariantProps } from "./ITabsVariantProps";
import {
    ContentArea,
    MobileNav,
    PageHeader,
    PageNav,
    PageTabButtons,
    TabPage,
} from "./SideTabs.styles";
import { TabButtons } from "./TabButtons";

interface ISideTabsProps extends ITabsVariantProps {
    sidebarContent?: ReactNode;
}

export const SideTabs = (props: ISideTabsProps) => {
    const { title, tabs, selected, onSelected, className, sidebarContent } =
        props;

    return (
        <TabPage className={className}>
            <PageHeader title={title} />
            <MobileNav>
                <TabButtons
                    mode="top"
                    tabs={tabs}
                    selected={selected}
                    onSelected={onSelected}
                />
            </MobileNav>
            <PageNav>
                <PageTabButtons
                    tabs={tabs}
                    selected={selected}
                    onSelected={onSelected}
                    mode="side"
                />
                {sidebarContent && <div>{sidebarContent}</div>}
            </PageNav>
            <ContentArea tabs={tabs} selected={selected} />
        </TabPage>
    );
};
